<template>
  <div>
    <v-btn icon @click="showQA()">
      <v-icon>help</v-icon>
    </v-btn>    
  </div>
</template>

<script>
export default {
  name: "optima-help",

  data: () => ({
  }),

  methods: {
    showQA()
    {
      this.$store.dispatch("setShowHelpList", true);
    }
  }

};
</script>

<style scoped>
</style>
